import { EventOverviewPanel } from "../../../components/admin/event-hub/EventOverviewPanel";

export function AdminEventOverviewPage() {
  return <EventOverviewPanel />;
}
